import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CompanyDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnChanges {
  companyForm: FormGroup;
  companyFormArray: FormGroup;
  control = new FormControl();
  @Input() companys: CompanyDto[];
  @Input() routeAnimationsElements: any;
  @Output() company = new EventEmitter<CompanyDto[]>();
  @Output() deleteCompanyEvent = new EventEmitter<any>();

  selectedCompany: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createCompanyForm();
  }

  createCompanyForm() {
    this.companyForm = this.fb.group({
      CompanyName: ['', Validators.required],
      id: null,
    });
    this.companyFormArray = this.fb.group({ Companys: this.fb.array([]) });
    this.setCompany();
  }

  // method to display companys
  setCompany() {
    const control = this.companyFormArray.controls.Companys as FormArray;
    this.companys.forEach((e) => {
      control.push(
        this.fb.group({
          CompanyName: e.CompanyName,
          id: e.id,
        })
      );
    });
  }

  // method to add Company
  addCompany(value: CompanyDto) {
    const control = this.companyFormArray.controls.Companys as FormArray;
    control.insert(
      0,
      this.fb.group({
        CompanyName: value.CompanyName,
      })
    );
  }

  selectCompany(value) {}

  // method to delete company from arrary list
  deleteCompany(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.companyFormArray.controls.Companys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.companys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.companys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: CompanyDto) {
    if (this.companyForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.companyFormArray
        .get('Companys')
        ['controls'][this.selectedIndex].patchValue({
          CompanyName: formValue.CompanyName,
        });
    } else {
      this.addCompany(formValue);
    }
    this.selectedIndex = null;
    this.companyForm.reset();
  }

  onEdit(index, value: CompanyDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.companyForm.patchValue({ CompanyName: value.CompanyName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.companyForm.reset();
  }

  onSubmit(formValue: CompanyDto[]) {
    this.company.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteCompanyEvent.emit(this.filteredDelete);
    }
  }
}
